import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { AutoSaveContext } from '../AutoSaveContext';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'plr-form-control-auto-save',
  templateUrl: './form-control-auto-save.component.html',
  styleUrls: ['./form-control-auto-save.component.scss']
})
export class FormControlAutoSaveComponent {
  @Input()
  context: AutoSaveContext;
}




// WEBPACK FOOTER //
// ./src/app/pillar/workspace/components/form-control-auto-save.component.ts